import React,{useState,useEffect} from 'react'
import SubHeader from '../../layout/components/SubHeader'
import dasbhoardService from '../../../services/dashboard.service'
import { useEyeconxStore } from '../../../store/eyeconxStore'
import clinicService from '../../../services/clinic.service'
import Loading from '../../common/Loading'
import StatCard from '../../common/StatCard'
function Dashboard() {
   const user = useEyeconxStore(state=>state.user)
   const setTodaysAppointment = useEyeconxStore(state=>state.setTodaysAppointment)
   const userInfo = useEyeconxStore(state=>state.userInfo)
   const setUserInfo = useEyeconxStore(state=>state.setUserInfo)
  const darkMode = false;  

   useEffect(()=>{
    getAppointments()
    //if userinfo object is set then do nothing else call getuserinfo
   
   },[])

   const getAppointments =()=>{
    dasbhoardService.getAppointment(user.clinicId)
      .then(res=>{
        setTodaysAppointment(res.data)
        //console.log("Appointment Data")
        //console.log(res.data)
       })
       .catch(err=>{
        //console.log(err)
       })
   }
  
  return (
    <>
        <SubHeader title="Dashboard" description={"Eyes On Sheppard | 500 Mb | 120 items"}/>
     
         {/* chatgpt */}
  <div className={darkMode ? "bg-dark text-light min-vh-100" : "bg-light text-dark min-vh-100"}>
      <div className="container-fluid py-4">
   
        {/* Quick Stats */}
        <div className="row g-4 mb-4">
          <div className="col-md-3">
            <StatCard
                title="Appointments"
                value="24"
                change="+3 Today"
                icon="bi-calendar-check-fill"
                color="primary"
                darkMode={darkMode}
            />
          </div>
          <div className="col-md-3">
          <StatCard
            title="Patients"
            value="132"
            change="Active"
            icon="bi-people-fill"
            color="success"
            darkMode={darkMode}
          />
          </div>
          <div className="col-md-3">
          <StatCard
            title="Messages Sent"
            value="78"
            change="This Month"
            icon="bi-chat-dots-fill"
            color="info"
            darkMode={darkMode}
          />
          </div>
          <div className="col-md-3">
          <StatCard
            title="Campaigns"
            value="5"
            change="Running"
            icon="bi-megaphone-fill"
            color="danger"
            darkMode={darkMode}
          />
          </div>
        </div>

        {/* Appointments + Communication */}
        <div className="row g-4 mb-4">
          <div className="col-lg-6">
            <CardWrapper title="Upcoming Appointments" darkMode={darkMode}>
              <ul className="list-group list-group-flush">
                <li className="list-group-item d-flex justify-content-between align-items-center hover-scale">
                  <div>
                    <strong>John Doe</strong>
                    <br />
                    <small className="text-muted">Sep 14, 10:00 AM</small>
                  </div>
                  <span className="badge bg-primary rounded-pill">Checkup</span>
                </li>
                <li className="list-group-item d-flex justify-content-between align-items-center hover-scale">
                  <div>
                    <strong>Jane Smith</strong>
                    <br />
                    <small className="text-muted">Sep 14, 11:30 AM</small>
                  </div>
                  <span className="badge bg-success rounded-pill">Consult</span>
                </li>
              </ul>
            </CardWrapper>
          </div>

          <div className="col-lg-6">
            <CardWrapper title="Patient Communication" darkMode={darkMode}>
              {[
                { type: "Email", value: 78, color: "primary" },
                { type: "SMS", value: 54, color: "success" },
                { type: "Calls", value: 22, color: "warning" },
              ].map((item) => (
                <div className="d-flex align-items-center mb-3" key={item.type}>
                  <div className="me-auto">
                    <strong>{item.type}</strong>
                    <br />
                    <small className="text-muted">{item.value}% Preference</small>
                  </div>
                  <div className="progress w-50">
                    <div
                      className={`progress-bar bg-${item.color}`}
                      style={{ width: `${item.value}%` }}
                    ></div>
                  </div>
                </div>
              ))}
            </CardWrapper>
          </div>
        </div>

        {/* Campaigns Table */}
        <CardWrapper title="Recent Campaigns" darkMode={darkMode}>
          <div className="table-responsive">
            <table className={`table align-middle ${darkMode ? "table-dark" : "table-striped"}`}>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Type</th>
                  <th>Status</th>
                  <th>Sent</th>
                </tr>
              </thead>
              <tbody>
                <tr className="hover-scale">
                  <td>September Newsletter</td>
                  <td>Email</td>
                  <td>
                    <span className="badge bg-success">Completed</span>
                  </td>
                  <td>250</td>
                </tr>
                <tr className="hover-scale">
                  <td>Feedback Survey</td>
                  <td>Survey</td>
                  <td>
                    <span className="badge bg-primary">Ongoing</span>
                  </td>
                  <td>132</td>
                </tr>
                <tr className="hover-scale">
                  <td>Reminder SMS</td>
                  <td>SMS</td>
                  <td>
                    <span className="badge bg-warning">Scheduled</span>
                  </td>
                  <td>-</td>
                </tr>
              </tbody>
            </table>
          </div>
        </CardWrapper>
      </div>

      {/* Custom CSS */}
      <style>{`
        .hover-scale {
          transition: transform 0.2s ease, box-shadow 0.2s ease;
        }
        .hover-scale:hover {
          transform: translateY(-3px);
          box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);
        }
        .stat-card {
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }
        .stat-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15);
        }
      `}</style>
    </div>

    </>
  )
}


// CardWrapper Component
const CardWrapper = ({ title, children, darkMode }) => (
  <div className={`card shadow-sm border-0 mb-4 ${darkMode ? "bg-secondary text-light" : ""}`}>
    <div className="card-header bg-white border-0 d-flex justify-content-between align-items-center">
      <h6 className="mb-0 fw-bold">{title}</h6>
    </div>
    <div className="card-body">{children}</div>
  </div>
);
export default Dashboard